import pl from '@/lib/calendesk-js-library/lang/pl_2'
import en from '@/lib/calendesk-js-library/lang/en_2'
import de from '@/lib/calendesk-js-library/lang/de_2'
import es from '@/lib/calendesk-js-library/lang/es_2'
import fr from '@/lib/calendesk-js-library/lang/fr_2'

// Every summary text the builder ever filled into a new booking section (wb_default_booking_created_summary in the
// js-library, all versions), per builder language. A section keeps the text that was current when it was created; a
// stock text becomes the current default of its own language, never of the language the builder is used in, so the
// site's language never changes. A text the business wrote or extended is never in this list and stays as written.
// The booking site (calendesk-website-builder-client, stockBookingSummary.ts) recognises the same list: change both.
const STOCK_BOOKING_SUMMARIES: Record<string, string[]> = {
  pl: [
    'Na twój adres e-mail wysłaliśmy potwierdzenie rezerwacji.',
    'Na Twój adres e-mail wysłaliśmy potwierdzenie rezerwacji.',
    'Szczegóły rezerwacji wysłaliśmy na Twój adres e-mail.'
  ],
  en: [
    'We have sent the booking confirmation to your email address.',
    'We have sent the booking details to your email address.'
  ],
  de: [
    'Eine Buchungsbestätigung wurde an Ihre E-Mail-Adresse geschickt.',
    'Eine Buchungsbestätigung wurde an deine E-Mail-Adresse geschickt.',
    'Die Details deiner Buchung haben wir an deine E-Mail-Adresse geschickt.'
  ],
  es: [
    'Hemos enviado una confirmación de reserva a su dirección de correo electrónico.',
    'Hemos enviado una confirmación de reserva a tu dirección de correo electrónico.',
    'Hemos enviado los detalles de la reserva a tu dirección de correo electrónico.'
  ],
  fr: [
    'Nous avons envoyé la confirmation de réservation à votre adresse e-mail.'
  ]
}

const CURRENT_BOOKING_SUMMARIES: Record<string, string> = {
  pl: (pl as Record<string, string>).wb_default_booking_created_summary,
  en: (en as Record<string, string>).wb_default_booking_created_summary,
  de: (de as Record<string, string>).wb_default_booking_created_summary,
  es: (es as Record<string, string>).wb_default_booking_created_summary,
  fr: (fr as Record<string, string>).wb_default_booking_created_summary
}

// The current default for an older stock text, in that text's language; null for any other text.
export function currentBookingSummary (text: string): string | null {
  const language = Object.keys(STOCK_BOOKING_SUMMARIES)
    .find(code => STOCK_BOOKING_SUMMARIES[code].includes(text.trim()))

  return language ? CURRENT_BOOKING_SUMMARIES[language] : null
}
